import { useMutation } from '@tanstack/react-query'

import { apiClient } from '../../lib/client.js'

/** Download a payment receipt PDF for a specific payment, via booking session auth */
export const useDownloadBookingSessionPaymentReceiptPdfMutation = () =>
  useMutation({
    mutationFn: async ({
      paymentId,
      sessionId,
    }: {
      paymentId: string
      sessionId: string
    }): Promise<Blob> => {
      const response = await apiClient.client.get<Blob>(
        `/booking-session/${sessionId}/payments/${paymentId}/receipt-pdf`,
        { responseType: 'blob' }
      )
      return response.data
    },
  })
